const configUrl = {
  API_URL: "https://betvdtdantoc.danang.gov.vn",
  MAIN_URL: "https://tvdtdantoc.danang.gov.vn",
  TEN_UNG_DUNG: "HỆ THỐNG THƯ VIỆN ĐIỆN TỬ DÂN TỘC",
  MA_TINH: 49,
  TEN_TINH: "Quảng Nam",
  footerText: `HỆ THỐNG THƯ VIÊN ĐIỆN TỬ BAN DÂN TỘC`,
};

export default configUrl;
